import React from 'react'
import { Section7Data } from '../../constants'
import { useStateContext } from '../../context/ContextProvider'
import {BentoGridItem,BentoGrid} from "../ui/BentoGrid"
import { renderText, truncateText } from '../hooks/TextVeiw'

const Section7Home = () => {
    const {currentLang}=useStateContext()
    const isAr = currentLang === 'ar';
  
  return (
    <div className='relative'>
        <section className='container'>
          <BentoGrid className="mt-12 md:mt-16 lg:mt-20">
            {Section7Data.map((item) => {
                const desc = isAr ? item.description_Ar : item.description_En;
                return(
              <BentoGridItem 
                key={item.id}
                image={item.image}
                subtitle={isAr ? item.subtitle_Ar : item.subtitle_En}
                title={isAr ? item.title_Ar : item.title_En}
                description={ renderText(desc,"text-light-subtitle dark:text-dark-subtitle text-body-3")}
                className={item.id === 1 ? "md:col-span-3 md:row-span-2" : 
                          item.id === 2 ? "md:col-span-2 md:row-span-2" : "md:col-span-1 md:row-span-1/2"}
                id={item.id}
              />
           ) })}
          </BentoGrid>
        </section>
    </div>
  )
}

export default Section7Home